<div class="component-container">

    <div class="update-password-container">
        <h1>Update Password</h1>
        <p class="description">Change your password to keep your account secure.</p>
        
        <div class="success-message" id="successMessage" [style.display]="passwordUpdated ? 'block' : 'none'">
            Your password has been updated successfully!
        </div>
        
        <form id="updatePasswordForm" #form="ngForm">
            <div class="form-group">
                <label for="currentPassword">Current Password</label>
                <div class="password-container">
                    <input [type]="toggle ? 'text' : 'password'" 
                    name="currentPassword" placeholder="Enter current password" 
                    [(ngModel)]="password" autocomplete="off" required minlength="8"
                    pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{8,}$" #currentPassword="ngModel" >
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggleView()">Show</button>
                </div>
                <div class="error-message" id="currentPasswordError" *ngIf="currentPassword.invalid && currentPassword.touched">
                    <ul>
                        <li *ngIf="currentPassword.errors?.['required']">Password is required</li>
                        <li *ngIf="currentPassword.errors?.['minlength']">Must be at least 8 characters long</li>
                        <li *ngIf="currentPassword.errors?.pattern">
                          Must include at least one uppercase letter, one number, and one special character
                        </li>
                      </ul>
                </div>
            </div>
            
            <div class="form-group">
                <label for="newPassword">New Password</label>
                <div class="password-container">
                    <input [type]="toggle2 ? 'text' : 'password'"
                     name="newPassword" placeholder="Enter new password"
                     [(ngModel)]="newPassword" autocomplete="off" required minlength="=8"
                     pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{8,}$" #newCredential="ngModel"
                     >
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggleView2()">Show</button>
                </div>
                <div class="error-message" id="newPasswordError" *ngIf="newCredential.invalid && newCredential.touched"></div>
                <div class="password-requirements">
                    Password must:
                    <ul>
                        <li>Be at least 8 characters long</li>
                        <li>Include at least one uppercase letter</li>
                        <li>Include at least one number</li>
                        <li>Include at least one special character</li>
                    </ul>
                </div>
            </div>
            
            <div class="form-group">
                <label for="confirmPassword">Confirm New Password</label>
                <div class="password-container">
                    <input [type]="toggle3 ? 'text' : 'password'"
                     name="confirmPassword" placeholder="Confirm new password"
                     [(ngModel)]="confirmPassword" autocomplete="off" required minlength="8"
                     pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{8,}$" #confirmNewCredential="ngModel"
                     >
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility" (click)="toggleView3()">Show</button>
                </div>
                <div class="error-message" id="confirmPasswordError" *ngIf="confirmNewCredential.invalid && confirmNewCredential.touched"></div>
            </div>
            
            <div class="button-group">
                <button type="button" class="btn btn-secondary" id="cancelButton" (click)="homeScreen()">Cancel</button>
                <button type="submit" class="btn btn-primary" (click)="updatePassword()" >Update Password</button>
            </div>
            
            <p class="back-link"><a [routerLink]="['/']">Back to Profile</a></p>
        </form>
    </div>

</div>